import React from 'react'
import { Form, Formik } from 'formik'
import Button from './common/Button'
import { required } from '../utils/validators'
import Input from './common/Input'

export default function IncomeDetailForm({ onSubmit, initialValues }) {
    return (
        <Formik onSubmit={onSubmit} initialValues={{ name: '', count: '', price: '', date: '', ...initialValues }}>
            <Form>
                <Input name="name" label="Маҳсулот номи" validate={required} />
                <Input name="count" label="Маҳсулот сони" validate={required} />
                <Input name="price" type="number" step="0.01" label="Маҳсулот нархи"
                    validate={required} />
                <Input name="date" type="date" label="Вақти"
                    validate={required} />
                <Button style={{ marginBottom: 12 }} text="Қўшиш" icon="add-outline" type="submit"
                    className="is-success" />
            </Form>
        </Formik>
    )
}
